import {useMutation, useQueryClient} from "react-query";
import Alert from "react-s-alert";

import {UserService} from "../../../../../services/UserService";
import {buildResponseErrorMessage} from "../../../../../services/api/errorHelpers";

/** Removes reporting permissions from multiple users. */
export const useBulkRemoveUserPermissions = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (userIds: ReadonlyArray<string>) => {
      await UserService.bulkPutReportingPermissions(
        userIds.map(userId => ({userId, permissions: []})),
      );
    },
    {
      onSuccess: (_, userIds) => {
        queryClient.invalidateQueries("usersPermissionQuery");
        userIds.forEach(userId => {
          queryClient.invalidateQueries(["useUserQuery", userId]);
        });
        Alert.success(
          `Removed permissions from ${userIds.length} user${
            userIds.length === 1 ? "" : "s"
          }`,
        );
      },
      onError: async (resp: unknown) => {
        Alert.warning(
          await buildResponseErrorMessage(
            resp,
            "Failed to remove permissions from selected users",
          ),
        );
      },
    },
  );
};
